<template>
    <div class='card'>
        <div class='card-body'>
            <h5 class="mb-0">National Materials</h5>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
